import { render, staticRenderFns } from "./DialogDelete.vue?vue&type=template&id=296fa7e8&scoped=true"
import script from "./DialogDelete.vue?vue&type=script&lang=js"
export * from "./DialogDelete.vue?vue&type=script&lang=js"
import style0 from "./DialogDelete.vue?vue&type=style&index=0&id=296fa7e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296fa7e8",
  null
  
)

export default component.exports